import React, { useCallback, useEffect, useState } from "react";
import { useRef } from "react";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import Modal from "../../../../components/Common/Modal/Modal";
import DefaultImagesIcon from "../../../../components/Common/SvgIcons/ManageIcons/DefaultImagesIcon";
// import ImagesLibraryIcon from "../../../../components/Common/SvgIcons/ManageIcons/ImagesLibraryIcon";
import UploadImagesIcon from "../../../../components/Common/SvgIcons/ManageIcons/UploadImagesIcon";
import LocalFileBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/LocalFileBigIcon";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import QuizImage from "../../../../components/Manage/QuizImage/QuizImage";
import { useFetchData } from "../../../../hooks/useFetchData";
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import {
  getExistingQuizImagesActionHandler,
  getQuizImagesActionHandler,
  postMultiQuizImagesActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import { useDispatch, useSelector } from "react-redux";
import { useCheckList } from "../../../../hooks/useCheckList";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { useLocation } from "react-router";
import classes from "./SelectThumbnail.module.scss";
import Loader from "../../../../components/Common/Loader/Loader";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import { eventAddQuizImageStoreAction } from "../../../../store/actions/actionCreators/eventActionCreator";
import useHashArray from "../../../../hooks/useHashArray";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

const SelectThumbnail = ({
  setActiveSection,
  name = "ThumbnailImage",
  isImagesCheckbox,
  questionListWatch,
  selectedQuestionIndex,
}) => {
  const pageSize = 15;
  const location = useLocation();
  const dispatch = useDispatch();
  const thumbnailImageRef = useRef();
  const [activeTab, setActiveTab] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [imageFiles, setImageFiles] = useState({});
  const [isReplaceModal, setIsReplaceModal] = useState(false);

  const [storeSelCheckboxImg, setStoreSelCheckboxImg] = useState([]);
  const manageState = useSelector((state) => state.manageReducer);
  const { uploadQuizImagesLoader } = manageState;
  // const eventState = useSelector((state) => state.eventReducer);
  // const { eventAddQuizImage } = eventState;
  let imageTabs = [
    {
      id: 1,
      name: "Default",
      icon: (fill) => <DefaultImagesIcon fill={fill} />,
    },
    {
      id: 2,
      name: <FormattedMessage id="UPLOAD_TEXT" />,
      icon: (fill) => <UploadImagesIcon fill={fill} />,
    },
    // {
    //   id: 3,
    //   name: "Library",
    //   icon: (fill) => <ImagesLibraryIcon fill={fill} />,
    // },
  ];
  const {
    data,
    totalRows,
    loading,
    setData,
    setUpdatedData,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getQuizImagesActionHandler, pageSize);
  const { ref } = useInfiniteScroll(handleCurrentPage, hasMoreData);

  useEffect(() => {
    if (data?.length >= totalRows) {
      setHasMoreData(false);
    } else {
      setHasMoreData(true);
    }
  }, [data, totalRows]);

  const handleReplaceModal = () => {
    setIsReplaceModal(!isReplaceModal);
  };
  const handleUploadImage = (e) => {
    let files = e.target.files;
    const filesSupported = ["jpeg", "png", "bmp", "jpg"];
    let valid = true;
    [...files].forEach((file) => {
      let lastIndexVal = (file?.name.lastIndexOf(".") - 1) >>> 0;
      let fileExtension = file?.name.slice(lastIndexVal + 2);
      if (!filesSupported.includes(fileExtension)) {
        valid = false;
        dispatch(
          setErrorHandler(errorTypes.WARN, `Please select a valid format`)
        );
        setValue(name, "");
        return;
      }
    });

    if (!valid) {
      return;
    }

    setImageFiles(() => files);
    if (files?.length < 5) {
      dispatch(loaders.manage.contentBulkUpload.uploadQuizImagesLoader(true));
      dispatch(getExistingQuizImagesActionHandler(files)).then(
        (isMediaExists) => {
          if (isMediaExists) {
            handleReplaceModal();
            dispatch(
              loaders.manage.contentBulkUpload.uploadQuizImagesLoader(false)
            );
          } else {
            dispatch(postMultiQuizImagesActionHandler(files)).then(
              (isUploaded) => {
                if (isUploaded) {
                  dispatch(
                    setErrorHandler(
                      errorTypes.SUCCESS,
                      `Images are uploaded successfully`
                    )
                  );
                  dispatch(
                    loaders.manage.contentBulkUpload.uploadQuizImagesLoader(
                      false
                    )
                  );
                  handleSearchQuery();
                  setActiveTab(() => 1);
                }
              }
            );
          }
        }
      );
    } else {
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          `Maximum of 4 images can be selected at a time`
        )
      );
    }
    // setActiveSection(1);
  };
  const handleReplaceBulkUploadImage = () => {
    dispatch(loaders.manage.contentBulkUpload.uploadQuizImagesLoader(true));
    dispatch(postMultiQuizImagesActionHandler(imageFiles)).then(
      (isUploaded) => {
        if (isUploaded) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Images are uploaded successfully`
            )
          );
          dispatch(
            loaders.manage.contentBulkUpload.uploadQuizImagesLoader(false)
          );
          handleSearchQuery();
          setActiveTab(() => 1);
        }
        handleReplaceModal();
      }
    );
  };

  const { handleCheckOne } = useCheckList(
    "Mediaid",
    data,
    setData,
    setUpdatedData
  );
  const handleImageSelected = () => {
    if (isImagesCheckbox) {
      var selectedImage = data?.filter((e) => e.checked === true).length;
      if (selectedImage > 2) {
        dispatch(
          setErrorHandler(
            errorTypes.WARN,
            "Maximum two image can be selected for a question"
          )
        );
      } else {
        setActiveSection(1);
        setStoreSelCheckboxImg([]);
        let uniqueImages = [
          ...new Set(storeSelCheckboxImg?.map((item) => item)),
        ];
        setValue(name, uniqueImages);
        if (storeSelCheckboxImg.length > 0) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Question images has been attached"
            )
          );
        }
      }
    }
  };
  const { setValue } = useFormContext({});
  const [questionListWatchImagesID, setQuestionListWatchImagesID] = useState();
  useEffect(() => {
    if (isImagesCheckbox) {
      if (questionListWatch?.length > 0) {
        questionListWatch?.map((item, index) => {
          let indexNo = index + 1;
          if (selectedQuestionIndex == indexNo && item.QuestionImage) {
            let uniqueIDs = [
              ...new Set(item?.QuestionImage?.map((item) => item.Mediaid)),
            ];
            setQuestionListWatchImagesID(uniqueIDs);
          }
        });
      }
    }
  }, [setQuestionListWatchImagesID]);

  useEffect(() => {
    if (isImagesCheckbox) {
      if (questionListWatch?.length > 0 && data.length > 0) {
        const updateData = data?.map((item) => {
          if (questionListWatchImagesID?.includes(item.Mediaid)) {
            return {
              ...item,
              checked: true,
            };
          } else {
            return { ...item, checked: false };
          }
        });
        setData(updateData);
      }
    }
  }, [data.length, questionListWatch]);
  useEffect(() => {
    if (isImagesCheckbox) {
      data.map((checkedData) => {
        if (checkedData?.checked === true) {
          setStoreSelCheckboxImg((prev) => [...prev, checkedData]);
        } else {
          let el = storeSelCheckboxImg?.find(
            (itm) => itm?.Mediaid === checkedData?.Mediaid
          );
          if (el) storeSelCheckboxImg?.splice(storeSelCheckboxImg.indexOf(el));
        }
      });
    }
  }, [data, setValue, setStoreSelCheckboxImg]);

  useEffect(() => {
    if (storeSelCheckboxImg.length > 0) {
      let uniqueData = [...new Set(storeSelCheckboxImg?.map((item) => item))];
      setStoreSelCheckboxImg(uniqueData);
    }
  }, [setStoreSelCheckboxImg]);
  return (
    <div className={classes.selectThumbnail}>
      <div className={classes.selectThumbnail__header}>
        <div className={classes.selectThumbnail__header__heading}>
          <FormattedMessage id="CREATE_THUMBNAIL_TEXT" />
        </div>
        <TabLinks
          tabs={imageTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          gap={3}
        />
      </div>
      {activeTab === 1 ? (
        <div className={classes.selectThumbnail__default} ref={ref}>
          {data?.length > 0 ? (
            <div className={classes.selectThumbnail__default__list}>
              {data.map((image, index) =>
                isImagesCheckbox == true ? (
                  <QuizImage
                    image={image}
                    name={name ? name : ""}
                    key={image.Mediaid}
                    value={image.checked}
                    fieldValue="Mediaid"
                    handleClick={handleCheckOne}
                    isImagesCheckbox={isImagesCheckbox}
                    // handleChange={(image) => handleChange(image)}
                  />
                ) : (
                  <QuizImage
                    image={image}
                    name={name}
                    key={image.Mediaid}
                    fieldValue={"MediaUri"}
                    selectType={"radio"}
                    handleChange={() => setActiveSection(1)}
                    index={index}
                  />
                )
              )}
            </div>
          ) : loading ? (
            <div className={classes.selectThumbnail__default__loading}>
              <div
                className={classes.selectThumbnail__default__loading__loader}
              >
                <Loader />
              </div>
            </div>
          ) : (
            <h1 className={classes.selectThumbnail__default__noImages}>
              <FormattedMessage id="NO_IMAGES" />
            </h1>
          )}
        </div>
      ) : activeTab === 2 ? (
        <div
          className={classes.selectThumbnail__upload}
          onClick={() => thumbnailImageRef.current.click()}
        >
          <Input
            type="file"
            name={name}
            hidden={true}
            reference={thumbnailImageRef}
            accept=".jpeg,.png,.bmp,.jpg"
            fileInputButton={false}
            fileInputName="false"
            onChange={(e) => handleUploadImage(e)}
            multiple
          />
          {uploadQuizImagesLoader ? (
            <Loader height={30} width={30} />
          ) : (
            <LocalFileBigIcon />
          )}
          <div className={classes.selectThumbnail__upload__heading}>
            Upload From Device
          </div>
          <div className={classes.selectThumbnail__upload__note}>
            * Format Supported .png, .jpg, .gif, .bmp
          </div>
          <div className={classes.selectThumbnail__upload__note}>
            * Upload high resolution thumbnail images example :<br /> 1280px
            width & 720px height (or) 1024px width & 576px height for better
            visibility
          </div>
        </div>
      ) : activeTab === 3 ? (
        <div></div>
      ) : (
        <></>
      )}
      {activeTab === 1 ? (
        <div className={classes.selectThumbnail__footer}>
          <div className={classes.selectThumbnail__footer__note}>
            Note : Preferred thumbnail sizes to upload 1280px width & 720px
            height for better visibility.
          </div>
          <div className={classes.selectThumbnail__footer__btns}>
            {isImagesCheckbox && (
              <Button
                label={<FormattedMessage id="P_SAVE_TXT" />}
                small
                dark
                type="button"
                onClick={handleImageSelected}
                // disabled={data?.filter((e) => e.checked === true).length < 1}
              />
            )}
            <Button
              label={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
              small
              dark
              type="button"
              onClick={() => setActiveSection(1)}
            />
          </div>
        </div>
      ) : (
        <div className={classes.selectThumbnail__footer}>
          <div className={classes.selectThumbnail__footer__btns2}>
            <Button
              label={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
              small
              dark
              type="button"
              onClick={() => setActiveSection(1)}
            />
          </div>
        </div>
      )}
      <Modal
        handleSubmit={handleReplaceBulkUploadImage}
        isOpen={isReplaceModal}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={handleReplaceModal}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        canClose={false}
        loading={uploadQuizImagesLoader}
      >
        <div className={classes.selectThumbnail__confirmModal}>
          <div className={classes.selectThumbnail__confirmModal__text}>
            <FormattedMessage id="IMAGE_EXISTS" />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SelectThumbnail;
